'use client'

/*
 * global-error.js replaces the root layout, so next/link and next/image are
 * unavailable here - raw <a> and <img> are required, not an oversight.
 * See node_modules/next/dist/docs/01-app/03-api-reference/03-file-conventions/error.md
 */
/* eslint-disable @next/next/no-html-link-for-pages, @next/next/no-img-element */

import { useEffect } from 'react'
import { isStaleClientError, reportClientError } from '@/app/_lib/clientErrorReporter'

/**
 * Root layout error boundary — the last line of defence.
 *
 * Must render its own html/body since it replaces the root layout, so it
 * cannot use next/image or next/link. Reporting is shared with every other
 * entry point via clientErrorReporter.
 */
export default function GlobalError({ error, reset }) {
    useEffect(() => {
        console.error('[Global Error Boundary]', error)

        // Auto-reload for stale client errors
        if (isStaleClientError(error)) {
            console.log('[Global Error Boundary] Stale client detected, reloading page...')
            window.location.reload()
            return
        }

        reportClientError({ error, type: 'global' })
    }, [error])

    // Global error must render its own html/body - can't use Next.js components
    return (
        <html>
            <body>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                    padding: '2rem',
                    fontFamily: 'system-ui, -apple-system, sans-serif',
                    textAlign: 'center'
                }}>
                    <a href="/" style={{ marginBottom: '2rem' }}>
                        <img
                            src="/images/hive-logo-gray.png"
                            alt="hive modern"
                            width={120}
                            height={60}
                        />
                    </a>
                    <h1 style={{ fontSize: '1.875rem', fontWeight: 300, marginBottom: '0.75rem' }}>
                        We hit a snag
                    </h1>
                    <p style={{ color: '#6b7280', marginBottom: '2rem', maxWidth: '28rem' }}>
                        Something unexpected happened. Please try again, or return to our homepage to continue shopping.
                    </p>
                    <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center' }}>
                        <button
                            onClick={() => reset()}
                            style={{
                                display: 'inline-block',
                                padding: '0.75rem 1.5rem',
                                backgroundColor: '#000000',
                                color: '#ffffff',
                                border: 'none',
                                borderRadius: '2px',
                                fontSize: '1rem',
                                fontWeight: '500',
                                cursor: 'pointer',
                                textAlign: 'center'
                            }}
                        >
                            Try again
                        </button>
                        <a
                            href="/"
                            style={{
                                display: 'inline-block',
                                padding: '0.75rem 1.5rem',
                                backgroundColor: '#ffffff',
                                color: '#000000',
                                border: '1px solid #000000',
                                borderRadius: '2px',
                                fontSize: '1rem',
                                fontWeight: '500',
                                textDecoration: 'none',
                                cursor: 'pointer',
                                textAlign: 'center'
                            }}
                        >
                            Go to homepage
                        </a>
                    </div>
                </div>
            </body>
        </html>
    )
}